import React, { useContext, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import { FavoritesContext } from "../Component/FavoritesContext";
import { useToast } from "../Component/ToastContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);
  const { toggleFavorite, isFavorite } = useContext(FavoritesContext);
  const { showToast } = useToast();
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(
    product?.size ? product.size[0] : ""
  );
  const [activeImage, setActiveImage] = useState(0);

  const formatPrice = (price) => {
    const numeric = Number(price);
    if (Number.isNaN(numeric)) return price;
    return `€ ${numeric.toLocaleString("en-EU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const handleQuantityChange = (delta) => {
    setQuantity((prev) => {
      const next = prev + delta;
      return next < 1 ? 1 : next;
    });
  };

  const handleFavoriteClick = () => {
    const result = toggleFavorite(product.id);
    if (!result.success) {
      showToast(result.message, "warning");
    } else {
      showToast(result.message, "success");
    }
  };

  const isVideo = (url) => /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(<span key={i} className="star filled">★</span>);
      } else if (i === fullStars && hasHalfStar) {
        stars.push(<span key={i} className="star half">★</span>);
      } else {
        stars.push(<span key={i} className="star empty">☆</span>);
      }
    }
    return stars;
  };

  if (!product) {
    return <div>Product not found</div>;
  }

  const handleAddToCart = () => {
    if (product.size && product.size.length > 0 && !selectedSize) {
      showToast("Please select a size", "warning");
      return;
    }
    addToCart(product.id, quantity, selectedSize);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="product-detail-page color-scheme color-scheme--scheme-1">
      <Header />
      <main className="product-detail">
        <div className="product-detail__layout">
          <section className="product-detail__gallery" aria-label="产品图片">
            <div className="product-detail__image-grid">
              {product.images.map((src, index) => (
                <figure
                  key={src}
                  className={`product-detail__grid-item${
                    index === activeImage ? " is-active" : ""
                  }`}
                  onClick={() => setActiveImage(index)}
                  onMouseEnter={() => setActiveImage(index)}
                >
                  {isVideo(src) ? (
                    <video src={src} autoPlay muted loop playsInline />
                  ) : (
                    <img src={src} alt={`${product.name} 图片 ${index + 1}`} />
                  )}
                </figure>
              ))}
            </div>
          </section>

          <section className="product-detail__info">
            <p className="product-detail__badge">ONLINE EXCLUSIVE</p>
            <h1 className="product-detail__title">{product.name}</h1>
            
            {product.rating && (
              <div className="product-detail__rating">
                <div className="stars">{renderStars(product.rating)}</div>
                <span className="rating-number">{product.rating}</span>
                <span className="review-count">({product.reviewCount} reviews)</span>
              </div>
            )}
            
            <p className="product-detail__price">{formatPrice(product.price)}</p>

            {product.size && product.size.length > 0 && (
              <div className="product-detail__sizes">
                <div className="product-detail__sizes-header">
                  <span className="product-detail__label">Size</span>
                </div>
                <div className="product-detail__size-grid">
                  {product.size.map((size) => (
                    <button
                      key={size}
                      type="button"
                      className={`product-detail__size${
                        size === selectedSize ? " is-selected" : ""
                      }`}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div className="product-detail__quantity">
              <div className="product-detail__quantity-control">
                <button
                  type="button"
                  onClick={() => handleQuantityChange(-1)}
                  aria-label="减少数量"
                >
                  -
                </button>
                <span>{quantity}</span>
                <button
                  type="button"
                  onClick={() => handleQuantityChange(1)}
                  aria-label="增加数量"
                >
                  +
                </button>
              </div>
            </div>

            <div className="product-detail__actions">
              <button
                type="button"
                className="product-detail__add"
                onClick={handleAddToCart}
              >
                ADD
              </button>
              <button
                type="button"
                className={`product-detail__favorite ${isFavorite(product.id) ? "is-favorited" : ""}`}
                onClick={handleFavoriteClick}
                aria-label={isFavorite(product.id) ? "Remove from favorites" : "Add to favorites"}
              >
                {isFavorite(product.id) ? "♥" : "♡"}
              </button>
            </div>

            <section className="product-detail__description">
              <h2>DESCRIPTION</h2>
              {product.description?.map((line) => (
                <p key={line}>{line}</p>
              ))}
            </section>

            {product.features && (
              <section className="product-detail__details">
                <button type="button">SEE DETAILS</button>
                <ul>
                  {product.features.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </section>
            )}
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProductDetail;
